import styled from "styled-components";

export const Separator = styled.div`
    width: 100%;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    margin: 10px 0 15px 0;
`;

export const ExpandedContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 10px;
    padding-top: 0;

    .expanded-section {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .section-title {
        font-size: 10px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: ${(props: any) => props.theme.colors.c64748b};
        margin-bottom: 8px;
    }
`;

export const TableContainer = styled.div`
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    overflow: hidden;
    width: 100%;

    .data-table {
        width: 100%;
        font-size: 10px;
        border-collapse: collapse;

        thead {
            background-color: var(--table-thead-bg);

            th {
                text-align: left;
                padding: 8px;
                font-weight: 500;
                font-size: 10px;
                color: ${({ theme }) => theme.colors.c000000};
                white-space: nowrap;

                &.field-col {
                    width: 35%;
                }

                &.before-col {
                    width: 30%;
                }

                &.after-col {
                    width: 35%;
                }
            }
        }

        tbody {
            tr {
                &.border-top {
                    border-top: 1px solid rgba(0, 0, 0, 0.1);
                }

                td {
                    padding: 8px;
                    vertical-align: top;
                    word-break: break-word;
                    font-size: 10px;

                    &.field-cell {
                        color: ${(props: any) => props.theme.colors.c64748b};
                    }

                    &.before-cell {
                        color: ${(props: any) => props.theme.colors.c64748b};
                    }

                    &.after-cell {
                        color: ${({ theme }) => theme.colors.c000000};
                        background-color: transparent;
                        font-weight: 500;

                        .highlight-bar {
                            display: none;
                        }

                        .after-content {
                            display: flex;
                            align-items: flex-start;
                            gap: 4px;
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 640px) {
        overflow-x: auto;

        .data-table {
            min-width: 280px;
        }
    }
`;

